import React, { useState, useMemo, useEffect } from "react";
import {
    Box,
    Typography,
    Button,
    Chip,
    TextField,
    InputAdornment,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import HeaderDashboard from "../../components/HeaderDashboard";
import { useUser } from "../../../contexts/UserContext";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from "react-router-dom";
import ModalNotificacao from "./ModalNotificacao";
import axios from "axios";
import CreditScoreIcon from '@mui/icons-material/CreditScore';
import { Breadcrumbs, Link } from "@mui/material";
import HomeIcon from '@mui/icons-material/Home';
import LocalAtmOutlinedIcon from '@mui/icons-material/LocalAtmOutlined';
import TaskAltOutlinedIcon from '@mui/icons-material/TaskAltOutlined';
import EventAvailableOutlinedIcon from '@mui/icons-material/EventAvailableOutlined';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
import DescriptionOutlinedIcon from '@mui/icons-material/DescriptionOutlined';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import HourglassBottomIcon from '@mui/icons-material/HourglassBottom';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';


const statusMap = {
    PENDING: { label: "Pendente", colorBg: "#fef3c7", colorText: "#b45309" },
    RECEIVED: { label: "Pago", colorBg: "#dcfce7", colorText: "#15803d" },
    RECEIVED_IN_CASH: { label: "Pago", colorBg: "#dcfce7", colorText: "#15803d" },
    CONFIRMED: { label: "Pago", colorBg: "#dcfce7", colorText: "#15803d" },
    OVERDUE: { label: "Vencida", colorBg: "#fee2e2", colorText: "#b91c1c" },
    DUNNING_REQUESTED: { label: "Vencida", colorBg: "#fee2e2", colorText: "#b91c1c" },
    DUNNING_RECEIVED: { label: "Vencida", colorBg: "#fee2e2", colorText: "#b91c1c" },
    REFUNDED: { label: "Reembolsada", colorBg: "#e0f2fe", colorText: "#0369a1" },
    REFUND_REQUESTED: { label: "Reembolso solicitado", colorBg: "#e0f2fe", colorText: "#0369a1" },
    REFUND_IN_PROGRESS: { label: "Reembolso em progresso", colorBg: "#e0f2fe", colorText: "#0369a1" },
    CHARGEBACK_REQUESTED: { label: "Chargeback", colorBg: "#fce7f3", colorText: "#be185d" },
    CHARGEBACK_DISPUTE: { label: "Chargeback", colorBg: "#fce7f3", colorText: "#be185d" },
    AWAITING_CHARGEBACK_REVERSAL: { label: "Chargeback", colorBg: "#fce7f3", colorText: "#be185d" },
    AWAITING_RISK_ANALYSIS: { label: "Análise de risco", colorBg: "#ffedd5", colorText: "#c2410c" },
    // Outros status podem ser adicionados aqui conforme necessário
};

const cardSx = {
    backgroundColor: "#fff",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
    p: { xs: 2, md: 3 },
};

const cabecalhoSx = { fontSize: 11, fontWeight: 700, letterSpacing: 0.6, color: "#6b7280", textTransform: "uppercase", borderBottom: "none", py: 1 };
const celulaSx = { fontSize: 13, color: "#374151", borderBottom: "1px solid #f3f4f6", py: 1.25 };

const moeda = (numero) => (Number(numero) || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

const CardResumo = ({ titulo, valor, icone }) => (
    <Box sx={{ ...cardSx, p: 2, display: "flex", flexDirection: "column", justifyContent: "space-between", gap: 2, minHeight: 110 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1 }}>
            <Typography sx={{ fontSize: 12, fontWeight: 700, letterSpacing: 0.8, color: "#374151", textTransform: "uppercase" }}>
                {titulo}
            </Typography>
            <Box
                sx={{
                    width: 30,
                    height: 30,
                    borderRadius: "8px",
                    backgroundColor: "#f3f4f6",
                    color: "#374151",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexShrink: 0,
                    "& svg": { fontSize: 18 },
                }}
            >
                {icone}
            </Box>
        </Box>
        <Typography sx={{ fontSize: { xs: 22, md: 24 }, fontWeight: 700, color: "#111827", lineHeight: 1.2 }}>{valor}</Typography>
    </Box>
);


const FaturasPagas = () => {
    const { user } = useUser();
    const navigate = useNavigate();

    const [busca, setBusca] = useState("");
    const [faturas, setFaturas] = useState([]);
    const [userActive, setUserActive] = useState(true);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [notificacoes, setNotificacoes] = useState([]);

    useEffect(() => {
        // Verifica se o usuário está com fatura vencida
        const hasFaturasVencidas = user?.faturas?.vencidas?.length > 0;

        if (hasFaturasVencidas) {
            setUserActive(false);
        } else {
            setUserActive(true);
        }
    }, [user]);

    useEffect(() => {
        const getNotify = async () => {
            const response = await axios.post(`${process.env.REACT_APP_API_URL}/buscarNotificacoes`, { email: localStorage.getItem("email") }, {
                headers: {
                    Authorization: `${localStorage.getItem("token")}`
                }
            });

            if (response.data.status === 200) {
                setNotificacoes(response.data.notificacoes)
            }
        }

        getNotify();
    }, [])


    function formatarDataBR(dataISO) {
        if (!dataISO) return "";
        const [ano, mes, dia] = dataISO.split("-");
        return `${dia}/${mes}/${ano}`;
    }

    useEffect(() => {
        if (!user || !user.faturas) return;

        const todasFaturas = [
            ...(user.faturas.pagas || []),
        ];

        const faturasFormatadas = todasFaturas.map((fatura, index) => {
            const statusInfo = statusMap[fatura.status] || { label: fatura.status, colorBg: "#f3f4f6", colorText: "#374151" };
            const dataPagamento = fatura.paymentDate || fatura.clientPaymentDate || "";

            return {
                id: index + 1,
                numero: fatura.nossoNumero || `FAT-${index + 1}`,
                vencimento: formatarDataBR(fatura.dueDate) || "—",
                pagamento: formatarDataBR(dataPagamento) || "—",
                dataPagamentoISO: dataPagamento || fatura.dueDate || "",
                valor: fatura.value || 0,
                status: statusInfo.label,
                faturaUrl: fatura.invoiceUrl || fatura.bankSlipUrl || "",
                colorBg: statusInfo.colorBg,
                colorText: statusInfo.colorText,
                billingType: fatura.billingType || "—",
            };
        });

        setFaturas(faturasFormatadas);
    }, [user]);

    const linhasFiltradas = useMemo(() => {
        const termo = busca.trim().toLowerCase();
        return faturas.filter(f => String(f.numero ?? "").toLowerCase().includes(termo));
    }, [faturas, busca]);

    const totalPago = faturas.reduce((soma, f) => soma + (Number(f.valor) || 0), 0);
    const ultimaData = faturas.reduce((maior, f) => (f.dataPagamentoISO > maior ? f.dataPagamentoISO : maior), "");

    return (
        <>
            <HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={notificacoes.length} />
            <Box sx={{ pt: "80px", pb: 4, px: { xs: 2, md: "5%" }, minHeight: "100vh" }}>
                <Box
                    sx={{
                        ...cardSx,
                        display: "flex",
                        flexDirection: { xs: "column", md: "row" },
                        alignItems: { xs: "stretch", md: "center" },
                        justifyContent: "space-between",
                        gap: 2,
                    }}
                >
                    <Box>
                        <Breadcrumbs aria-label="breadcrumb" sx={{ fontSize: 12, "& .MuiBreadcrumbs-separator": { mx: 0.5 } }}>
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer", fontSize: 12, color: "#6b7280" }}
                                onClick={() => navigate("../Dashboard")}
                            >
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Dashboard
                            </Link>
                            <Typography sx={{ fontSize: 12, color: "#111827", fontWeight: 600, display: 'flex', alignItems: 'center' }}>
                                <CreditScoreIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Faturas Pagas
                            </Typography>
                        </Breadcrumbs>
                        <Typography sx={{ mt: 1, fontSize: { xs: 20, md: 24 }, fontWeight: 700, color: "#111827" }}>
                            Faturas Pagas
                        </Typography>
                        <Typography sx={{ mt: 0.5, fontSize: 14, color: "#4b5563" }}>
                            Histórico das faturas já quitadas da sua assinatura.
                        </Typography>
                    </Box>
                    <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
                        <Button
                            startIcon={<ArrowBackIcon />}
                            onClick={() => navigate("../Dashboard")}
                            sx={{ textTransform: "none", fontSize: 13, fontWeight: 600, color: "#374151", backgroundColor: "#f3f4f6", borderRadius: "8px", px: 2, "&:hover": { backgroundColor: "#e5e7eb" } }}
                        >
                            Voltar
                        </Button>
                        <Button
                            startIcon={<HourglassBottomIcon />}
                            onClick={() => navigate("../Dashboard/Faturas/Pendentes")}
                            sx={{ textTransform: "none", fontSize: 13, fontWeight: 600, color: "#374151", backgroundColor: "#f3f4f6", borderRadius: "8px", px: 2, "&:hover": { backgroundColor: "#e5e7eb" } }}
                        >
                            Faturas pendentes
                        </Button>
                    </Box>
                </Box>

                <Box
                    sx={{
                        mt: 2,
                        display: "grid",
                        gridTemplateColumns: { xs: "1fr", sm: "repeat(3, 1fr)" },
                        gap: 2,
                    }}
                >
                    <CardResumo titulo="Total pago" valor={moeda(totalPago)} icone={<LocalAtmOutlinedIcon />} />
                    <CardResumo titulo="Faturas pagas" valor={faturas.length} icone={<TaskAltOutlinedIcon />} />
                    <CardResumo titulo="Último pagamento" valor={formatarDataBR(ultimaData) || "—"} icone={<EventAvailableOutlinedIcon />} />
                </Box>

                <Box sx={{ ...cardSx, mt: 2 }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1.5, flexWrap: "wrap", mb: 2 }}>
                        <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                            <Box sx={{ width: 36, height: 36, borderRadius: "8px", backgroundColor: "#f3f4f6", color: "#374151", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                <CreditScoreIcon sx={{ fontSize: 20 }} />
                            </Box>
                            <Box>
                                <Typography sx={{ fontSize: 16, fontWeight: 700, color: "#111827" }}>Histórico de faturas</Typography>
                                <Typography sx={{ fontSize: 12, color: "#6b7280" }}>
                                    {faturas.length} {faturas.length === 1 ? "fatura quitada" : "faturas quitadas"}
                                </Typography>
                            </Box>
                        </Box>
                        <TextField
                            placeholder="Buscar por Nº da fatura"
                            size="small"
                            value={busca}
                            onChange={(e) => setBusca(e.target.value)}
                            sx={{ width: { xs: "100%", sm: 300 }, "& .MuiOutlinedInput-root": { borderRadius: "8px", backgroundColor: "#fff", fontSize: 13 } }}
                            slotProps={{
                                input: {
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <Search sx={{ fontSize: 18, color: "#6b7280" }} />
                                        </InputAdornment>
                                    )
                                }
                            }}
                        />
                    </Box>

                    <TableContainer sx={{ overflowX: "auto" }}>
                        <Table sx={{ minWidth: 700 }}>
                            <TableHead>
                                <TableRow sx={{ backgroundColor: "#f3f4f6", "& th:first-of-type": { borderRadius: "6px 0 0 6px" }, "& th:last-of-type": { borderRadius: "0 6px 6px 0" } }}>
                                    <TableCell sx={cabecalhoSx}>Fatura</TableCell>
                                    <TableCell sx={cabecalhoSx}>Vencimento</TableCell>
                                    <TableCell sx={cabecalhoSx}>Pagamento</TableCell>
                                    <TableCell sx={cabecalhoSx}>Forma</TableCell>
                                    <TableCell sx={cabecalhoSx} align="right">Valor</TableCell>
                                    <TableCell sx={cabecalhoSx} align="center">Status</TableCell>
                                    <TableCell sx={cabecalhoSx} align="center">Fatura</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {linhasFiltradas.length > 0 ? (
                                    linhasFiltradas.map((fatura) => {
                                        const isCartao = fatura.billingType === "CREDIT_CARD";
                                        return (
                                            <TableRow key={fatura.id} hover>
                                                <TableCell sx={celulaSx}>
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                                                        <Box sx={{ width: 32, height: 32, borderRadius: "8px", backgroundColor: "#f0fdf4", color: "#16a34a", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                                                            <TaskAltOutlinedIcon sx={{ fontSize: 18 }} />
                                                        </Box>
                                                        <Box>
                                                            <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#111827" }}>{fatura.numero}</Typography>
                                                            <Typography sx={{ fontSize: 11, color: "#6b7280" }}>#{fatura.id}</Typography>
                                                        </Box>
                                                    </Box>
                                                </TableCell>
                                                <TableCell sx={celulaSx}>
                                                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                                                        <EventOutlinedIcon sx={{ fontSize: 16, color: "#9ca3af" }} />
                                                        {fatura.vencimento}
                                                    </Box>
                                                </TableCell>
                                                <TableCell sx={celulaSx}>{fatura.pagamento}</TableCell>
                                                <TableCell sx={celulaSx}>
                                                    <Chip
                                                        icon={isCartao ? <CreditCardIcon /> : <DescriptionOutlinedIcon />}
                                                        label={isCartao ? "Cartão" : "Boleto"}
                                                        size="small"
                                                        sx={{ backgroundColor: "#f3f4f6", color: "#374151", fontWeight: 600, fontSize: 11, height: 22, "& .MuiChip-icon": { fontSize: 14, color: "#6b7280" } }}
                                                    />
                                                </TableCell>
                                                <TableCell sx={{ ...celulaSx, fontWeight: 700, color: "#111827", whiteSpace: "nowrap" }} align="right">
                                                    {moeda(fatura.valor)}
                                                </TableCell>
                                                <TableCell sx={celulaSx} align="center">
                                                    <Chip
                                                        label={fatura.status}
                                                        size="small"
                                                        sx={{ backgroundColor: fatura.colorBg, color: fatura.colorText, fontWeight: 700, fontSize: 10, height: 20, letterSpacing: 0.4, textTransform: "uppercase" }}
                                                    />
                                                </TableCell>
                                                <TableCell sx={celulaSx} align="center">
                                                    <Button
                                                        size="small"
                                                        startIcon={<VisibilityOutlinedIcon sx={{ fontSize: "16px !important" }} />}
                                                        disabled={!fatura.faturaUrl}
                                                        onClick={() => window.open(fatura.faturaUrl, "_blank")}
                                                        sx={{ textTransform: "none", fontSize: 12, fontWeight: 600, color: "#374151", backgroundColor: "#f3f4f6", borderRadius: "8px", px: 1.5, whiteSpace: "nowrap", "&:hover": { backgroundColor: "#e5e7eb" } }}
                                                    >
                                                        Ver fatura
                                                    </Button>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={7} align="center" sx={{ borderBottom: "none", py: 6 }}>
                                            <CreditScoreIcon sx={{ fontSize: 36, color: "#d1d5db" }} />
                                            <Typography sx={{ mt: 1, fontSize: 14, fontWeight: 600, color: "#374151" }}>
                                                Nenhuma fatura encontrada.
                                            </Typography>
                                            <Typography sx={{ fontSize: 12, color: "#6b7280" }}>
                                                {faturas.length > 0 ? "Tente buscar por outro número de fatura." : "Suas faturas quitadas aparecerão aqui."}
                                            </Typography>
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Box sx={{ mt: 2, display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, flexWrap: "wrap", backgroundColor: "#f3f4f6", borderRadius: "8px", px: 1.5, py: 1 }}>
                        <Typography sx={{ fontSize: 12, color: "#6b7280" }}>
                            Exibindo <Box component="span" sx={{ color: "#111827", fontWeight: 700 }}>{linhasFiltradas.length}</Box> de {faturas.length} faturas
                        </Typography>
                        <Typography sx={{ fontSize: 12, color: "#6b7280" }}>
                            Total: <Box component="span" sx={{ color: "#111827", fontWeight: 700 }}>{moeda(linhasFiltradas.reduce((s, f) => s + (Number(f.valor) || 0), 0))}</Box>
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <ModalNotificacao
                openModalNotificacao={openModalNotificacao}
                onClose={() => setOpenModalNotificacao(false)}
                notificacoes={notificacoes}
            />
        </>
    );
};

export default FaturasPagas;
